import { render, staticRenderFns } from "./WithdrawRecordForm.vue?vue&type=template&id=0f88c5ce&"
import script from "./WithdrawRecordForm.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports